export interface IImageUploaderState {
    settings: IImageUploaderSettings;
    image: IImageUploaderImageData;
}

export interface IImageUploaderSettings {
    showBoxAround: boolean;
}

export interface IImageUploaderImageData {
    url: string;
    size: number;
    dateUploaded?: string;
    altText: string;
    type: string;
}

const DefaultState: IImageUploaderState = {
    settings: {
        showBoxAround: false,
    },
    image: {
        url: '',
        size: 0,
        altText: '',
        type: '',
    },
};

export default DefaultState;
